import React from 'react';
import Icon from '../../../components/AppIcon';

const UsageInstructions = ({ instructions }) => {
  return (
    <div className="p-6 md:p-8 rounded-xl bg-card border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-secondary/10 border border-secondary/30 flex items-center justify-center">
          <Icon name="BookOpen" size={20} color="var(--color-secondary)" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground">
          Usage Instructions
        </h2>
      </div>
      <div className="space-y-6">
        {instructions?.map((instruction, index) => (
          <div key={index} className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-sm font-bold text-primary data-text">
                  {index + 1}
                </span>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
                  {instruction?.title}
                </h3>
                <p className="text-base text-muted-foreground leading-relaxed">
                  {instruction?.description}
                </p>
              </div>
            </div>
            {instruction?.warning && (
              <div className="ml-11 p-4 rounded-lg bg-warning/10 border border-warning/30 flex items-start gap-3">
                <Icon name="AlertTriangle" size={18} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                <p className="text-sm text-foreground">
                  <span className="font-semibold">Warning:</span> {instruction?.warning}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-lg bg-muted/50 border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <p className="text-sm text-muted-foreground">
            Always consult with a healthcare professional before starting any peptide regimen. Individual results may vary based on factors such as age, health status, and lifestyle.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UsageInstructions;